<template>
  <div id="app">
    <div class="working" v-if="isWorking">Working</div>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'app',
  data () {
    return {
      meta: {
        fi: {
          url: 'https://unelma.raasepori.fi/fi/',
          title: 'Raaseporin Unelmakone',
          description: 'Mistä sinä unelmoit? Raaseporin Unelmakoneen avulla unelmasi voivat käydä toteen. Palkintona on kahden hengen miniloma Raaseporissa.',
          image: '/img/images/unelmakone-somejako-suomi.jpg'
        },
        sv: {
          url: 'https://drom.raseborg.fi/sv/',
          title: 'Raseborgs Drömmaskin',
          description: 'Vad drömmer du om? Med hjälp av drömmaskinen kan dina drömmar bli sanna. Priset är en två personers minisemester i Raseborg.',
          image: '/img/images/unelmakone-somejako-svenska.jpg'
        }
      }
    }
  },
  metaInfo () {
    return {
      title: this.meta[this.language].title,
      titleTemplate: null,
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
          vmid: 'twitter:card'
        },
        {
          name: 'twitter:site',
          content: this.meta[this.language].title,
          vmid: 'twitter:site'
        },
        {
          name: 'twitter:title',
          content: this.meta[this.language].title,
          vmid: 'twitter:title'
        },
        {
          name: 'twitter:description',
          content: this.meta[this.language].description,
          vmid: 'twitter:description'
        },
        {
          name: 'twitter:image',
          content: 'https://unelma.bojaco.com' + this.meta[this.language].image,
          vmid: 'twitter:image'
        },
        {
          property: 'og:title',
          content: this.meta[this.language].title,
          vmid: 'og:title'
        },
        {
          property: 'og:type',
          content: 'website',
          vmid: 'og:type'
        },
        {
          property: 'og:url',
          content: this.meta[this.language].url,
          vmid: 'og:url'
        },
        {
          property: 'og:image',
          content: 'https://unelma.bojaco.com' + this.meta[this.language].image,
          vmid: 'og:image'
        },
        {
          property: 'og:description',
          content: this.meta[this.language].description,
          vmid: 'og:description'
        },
        {
          property: 'og:site_name',
          content: this.meta[this.language].title,
          vmid: 'og:site_name'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isWorking']),
    ...mapState(['language'])
  },
  methods: {
    restart () {
      this.$store.commit('resetPoints')
    }
  }
}
</script>

<style lang="scss">

</style>
